import request from '@/utils/request';

export function getRechargeGroupSetting(params) {
  return request({
    url: `/organization/rechargeGroup?userId=${params.userId}`,
    method: 'get'
  });
}